import useFetch from './useFetch'

/**
 * React hook to fetch data from the GraphQL endpoint.
 * This is the wrapper over `useFetch` hook
 * @param {Object} args
 * @param {*} args.defaultFetchArgs arguments, passed to `fetchFn` on hook initialization
 * @param {function} args.fetchFn Required. Function to fetch data from the remote endpoint.
 * Endpoint has to fetch data from GraphQL.
 * It has to return fetch-based promise.
 * When this function is called on hook initialization - it will receive `defaultFetchArgs` from the hook arguments
 * When `refetch` is called - this function will be called and will receive arguments from refetch
 * @param {function} mapResponse Function that maps response data before saving in state
 * @param {boolean} skipFetchOnInit Do not fetch data when hook is initialized. Defaults to false
 * @param {*} defaultData Value that is set to `data` before fetch response is received.
 * It is set to data when hook is initialized and when `refetch` is called. Defaults to nul
 * @param {function} args.fetchId Optional. Id to use in hook id to prevent fetching the same request
 *
 * @returns {UseFetchResponse}
 */
const useGraphQLFetch = ({
  fetchFn,
  defaultFetchArgs,
  mapResponse,
  skipFetchOnInit,
  defaultData,
  fetchId,
}) => {
  const validateResult = result => {
    if (result.errors && result.errors[0]) {
      const isValid = false
      const errorMessage = result.errors[0].message
      return [isValid, errorMessage]
    }

    const isValid = true
    const errorMessage = null
    return [isValid, errorMessage]
  }

  const mapGraphQLResponse = response => {
    const data = response.data
    if (typeof mapResponse === 'function') return mapResponse(data)

    return data
  }

  return useFetch({
    fetchFn,
    defaultFetchArgs,
    mapResponse: mapGraphQLResponse,
    validateResult,
    skipFetchOnInit,
    defaultData,
    fetchId,
  })
}

export default useGraphQLFetch



// WEBPACK FOOTER //
// ./src/Utils/Hooks/useGraphQLFetch.js